// src/pages/ConfiguracaoFrete.js

import React, { useEffect, useMemo, useState } from "react";
import axios from "../axiosConfig";
import { Link } from "react-router-dom";
import { ArrowLeft, CheckCircle2, Save, Truck } from "lucide-react";
import "./ConfiguracaoFrete.css";

import ModalSemPermissao from "../components/ModalSemPermissao";

function ConfiguracaoFreteConteudo() {
  const [valores, setValores] = useState({ km: "", kg: "", m3: "" });
  const [mensagens, setMensagens] = useState({});
  const [erros, setErros] = useState({});
  const [salvando, setSalvando] = useState(null);

  const usuario = JSON.parse(localStorage.getItem("usuario"));

  const podeEditarFrete =
    usuario?.tipo === "admin" &&
    usuario?.permissoes?.some(
      (p) =>
        p.rota === "configuracoes-frete" &&
        p.pode_editar
    );

  useEffect(() => {
    const carregarValores = async () => {
      try {
        const [resKm, resKg, resM3] = await Promise.all([
          axios.get("/configuracoes/valor-por-km"),
          axios.get("/configuracoes/valor-por-kg"),
          axios.get("/configuracoes/valor-por-m3"),
        ]);

        setValores({
          km: resKm.data.valor ?? "",
          kg: resKg.data.valor ?? "",
          m3: resM3.data.valor ?? "",
        });
      } catch {
        setErros({
          km: "Erro ao carregar valor por KM.",
          kg: "Erro ao carregar valor por KG.",
          m3: "Erro ao carregar valor por m³.",
        });
      }
    };

    carregarValores();
  }, []);

  const salvarValor = async (tipo) => {
    setMensagens({});
    setErros({});

    const valorNumerico = Number(valores[tipo]);

    if (!valorNumerico || valorNumerico <= 0) {
      setErros((prev) => ({
        ...prev,
        [tipo]: "Informe um valor maior que zero.",
      }));
      return;
    }

    const endpoint = {
      km: "/configuracoes/valor-por-km",
      kg: "/configuracoes/valor-por-kg",
      m3: "/configuracoes/valor-por-m3",
    }[tipo];

    setSalvando(tipo);

    try {
      await axios.post(endpoint, { valor: valores[tipo] });
      setMensagens((prev) => ({
        ...prev,
        [tipo]: "Valor atualizado com sucesso.",
      }));
    } catch (err) {
      console.error(`Erro ao salvar ${tipo}:`, err);
      setErros((prev) => ({
        ...prev,
        [tipo]: `Erro ao atualizar valor por ${tipo}.`,
      }));
    } finally {
      setSalvando(null);
    }
  };

  const cards = useMemo(
    () => [
      {
        tipo: "km",
        titulo: "Valor por KM",
        descricao: "Usado para cálculo por distância percorrida.",
        label: "Valor por KM (R$)",
      },
      {
        tipo: "kg",
        titulo: "Valor por KG",
        descricao: "Usado para cálculo por peso do prêmio.",
        label: "Valor por KG (R$)",
      },
      {
        tipo: "m3",
        titulo: "Valor por m³",
        descricao: "Usado para cálculo por volume do produto.",
        label: "Valor por m³ (R$)",
      },
    ],
    []
  );

    if (!podeEditarFrete) {
    return (
      <ModalSemPermissao
        onClose={() => {
          window.location.href = "/";
        }}
      />
    );
  }

  return (
    <div className="freteConfigAdmin-page">
      <div className="freteConfigAdmin-topbar">
        <div>
          <span className="freteConfigAdmin-kicker">Configurações</span>
          <h2>Configuração de Frete</h2>
          <p>
            Configure os valores de referência para cálculo de frete por
            distância, peso e volume.
          </p>
        </div>

        <Link to="/" className="freteConfigAdmin-btn secondary">
          <ArrowLeft size={16} />
          Voltar
        </Link>
      </div>

      <div className="freteConfigAdmin-grid">
        {cards.map((card) => (
          <section key={card.tipo} className="freteConfigAdmin-card">
            <div className="freteConfigAdmin-cardHeader">
              <div>
                <h3>{card.titulo}</h3>
                <span>{card.descricao}</span>
              </div>

              <Truck size={18} />
            </div>

            <div className="freteConfigAdmin-cardBody">
              <div className="freteConfigAdmin-field">
                <label>{card.label}</label>
                <input
                  type="number"
                  step="0.01"
                  min="0.01"
                  value={valores[card.tipo]}
                  onChange={(e) =>
                    setValores((prev) => ({
                      ...prev,
                      [card.tipo]: e.target.value,
                    }))
                  }
                />
              </div>

              <button
                type="button"
                className="freteConfigAdmin-btn primary"
                onClick={() => salvarValor(card.tipo)}
                disabled={salvando === card.tipo}
              >
                <Save size={16} />
                {salvando === card.tipo ? "Salvando..." : "Salvar"}
              </button>

              {mensagens[card.tipo] && (
                <div className="freteConfigAdmin-alert success">
                  <CheckCircle2 size={15} />
                  {mensagens[card.tipo]}
                </div>
              )}

              {erros[card.tipo] && (
                <div className="freteConfigAdmin-alert danger">
                  {erros[card.tipo]}
                </div>
              )}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}

export default function ConfiguracaoFrete() {
  return <ConfiguracaoFreteConteudo />;
}